// used for a grid that contains qty fields that update the price/total price fields

bq.gridSummary = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.$grid = false;
  this.$summary = false;
  this.$isQuickOrder = false;
};

bq.gridSummary.DEFAULTS = {
  gridContainer: 'tbody',
  rowParent: 'tr',
  qtyInput: '.qty',
  qtyLabel: '.item-qty',
  itemPrice: '.item-price',
  itemTotal: '.item-total',
  itemTotalBase: '.item-total-base',
  summaryParent: '.product-summary',
  summaryCount: '.summary-count',
  summaryTotal: '.summary-total',
  highlightChange: false, //if set to a class it will add that class to the rowParent
  highlightNotice: true, //when set to true and icon will appear by the input with message below
  highlightMessage: bq.messages.global.qtyHasChanged,
  showEmpty: true,
  canRemoveRow: false
};

bq.gridSummary.prototype = {
  init: function() {
    bq.debug.log("Grid Summary : init()", this.$element);

    this.$grid = this.$element.find('table:not(".hidden") ' + this.options.gridContainer);
    this.$summary = $(this.options.summaryParent, this.$element);

    if(!this.$grid || !this.$summary) {
      bq.debug.log("Grid Summary : No grid and/or summary container found : exiting");
      return;
    }

    if(this.options.highlightChange) {
      this.setOrigQty();
    }

    this.update();

    //catch event to update calculation
    this.$element.on('bq.gridSummary.change', {thiz: this},  this.catchEventChange);

    //catch event to reset summary like it was first time ran
    this.$element.on('bq.gridSummary.reset', {thiz: this},  this.catchEventReset);

    //on qty change, update the calculations
    this.$grid.on('change', this.options.qtyInput, {thiz: this}, this.catchEventQtyChange);

    this.$element.on('bq.quickOrder.loadEnd bq.quickOrder.clear', {thiz: this}, this.catchEventQuickOrder);


  },

  update: function() {
    this.calculateItems();
    this.calculateSummary();
    this.throwEventUpdated();
  },
  getPriceContainerPrice: function (priceContainer) {
    if (priceContainer.is(':input')) {
      return priceContainer.val();
    } else {
      return priceContainer.text();
    }
  },
  isCustomItemPrice: function (priceContainer) {
    var currentPrice = this.getPriceContainerPrice(priceContainer);
    var originalResponsePrice = priceContainer.data('price_value') ? priceContainer.data('price_value') : this.getPriceContainerPrice(priceContainer);
    return accounting.unformat(currentPrice) != accounting.unformat(originalResponsePrice);
  },
  calculateItems: function() {
    var rows = this.$grid.find(this.options.rowParent + ':not(".hidden")'),
        warning = false,
        $this = this;

    rows.each(function() {
      var row = $(this),
          qtyInput = row.find($this.options.qtyInput),
          itemPrice = 0.00,
          itemPriceUnit = 0.00,
          qty = qtyInput.val(),
          minQty = parseFloat(qtyInput.prop('min')),
          qtyToCompare = isNaN(minQty) || minQty === 0 ? 1 : minQty,
          total = 0.00;

      var priceContainer = row.find($this.options.itemPrice);

      if(priceContainer.is(':input')) {
        itemPriceUnit = priceContainer.val();
      } else {
        itemPriceUnit = priceContainer.text();
      }

      if(qty <= 0 || qty === '' || isNaN(qty)) {
        qty = 0;
        if($this.options.showEmpty) { qtyInput.val('0'); } else { qtyInput.val(''); }
        total = 0.00;
      }

      itemPriceUnit = accounting.unformat(itemPriceUnit);

      var isAllowedToBeUpdated = $this.$isQuickOrder ? true : !$this.isCustomItemPrice(priceContainer);

      if (priceContainer.data('price_format')) {
        var mf = priceContainer.data('price_format');
      }

      //tier prices handling
      var checkItemTierPrice = Array.isArray(priceContainer.data('tier_prices')) && priceContainer.data('tier_prices').length;
      if(qty >= qtyToCompare && checkItemTierPrice && isAllowedToBeUpdated) {
        //get the most original price from json response, without any custom options
        if (priceContainer.data('price_value')) {
          itemPriceUnit = priceContainer.data('price_value');
        }

        //apply the best tier price
        itemPriceUnit = accounting.unformat(itemPriceUnit);
        itemPriceUnit = $this.getMinTierPrice(priceContainer.data('tier_prices'), itemPriceUnit, qty);

        //apply selected in popup extra price from custom options
        if (priceContainer.data('extra_price')) {
          itemPriceUnit += parseFloat(priceContainer.data('extra_price'));
        }

        itemPrice = itemPriceUnit;
        //format price
        if (typeof mf != 'undefined' ) {
          itemPrice = accounting.formatMoney(itemPrice, '', mf.precision, mf.groupSymbol, mf.decimalSymbol);
          itemPrice = mf.pattern.replace('%s', itemPrice);
        }
        if (priceContainer.data('price_tpl')) {
          itemPrice = priceContainer.data('price_tpl').replace('%s', itemPriceUnit);
        }

        //show prepared price
        if(priceContainer.is(':input')) {
          priceContainer.val(accounting.unformat(itemPrice));
        } else {
          priceContainer.text(itemPrice);
        }
      }

      if(qty >= qtyToCompare) {
        total = qty * accounting.unformat(itemPriceUnit);

        if(total === 0 || total === '' || !total || isNaN(total)) { total = 0.00; }
      }

      if($this.options.highlightChange) {
        if(qty != qtyInput.data('orig')) {
          row.addClass($this.options.highlightChange);
          $this.highlightNotice(qtyInput, true);
        } else {
          row.removeClass($this.options.highlightChange);
          $this.highlightNotice(qtyInput, false);
        }
      }

      var $_itemTotal = row.find($this.options.itemTotal);

      if(qty === 0 || total === 0.00 && !$this.options.showEmpty) {
        row.find($this.options.qtyLabel).text('');
      }

      if(total.toString().length > 4) {
        $_itemTotal.attr('data-original-title', accounting.formatMoney(total));
      } else {
        $_itemTotal.attr('data-original-title','');
      }

      if (typeof mf != 'undefined' ) {
        var totalPrecision = mf.totalPrecision || mf.precision;
        $_itemTotal.text(mf.pattern.replace('%s', accounting.formatMoney(total, '', totalPrecision, mf.groupSymbol, mf.decimalSymbol)));
        if (priceContainer.data('price_base')) {
          var itemPriceBase = priceContainer.data('price_base');
          var itemTotalBase = qty * accounting.unformat(itemPriceBase);
          var $itemTotalBaseContainer = row.find($this.options.itemTotalBase);
          $itemTotalBaseContainer.text(itemTotalBase);
          warning = !!total;
        }
        if (priceContainer.data('price_min') && priceContainer.data('price_max') && priceContainer.data('hasOptions')) {
          $_itemTotal.text(mf.pattern.replace(
            '%s',
            accounting.formatMoney(priceContainer.data('price_min'), '', totalPrecision, mf.groupSymbol, mf.decimalSymbol),
          ) + ' - ' + mf.pattern.replace(
            '%s',
            accounting.formatMoney(priceContainer.data('price_max'), '', totalPrecision, mf.groupSymbol, mf.decimalSymbol),
          ));
        }
      } else {
        $_itemTotal.text(accounting.formatMoney(total));
      }

      if(qty == 0) {
        $_itemTotal.text('');
      } else if ($this.options.canRemoveRow) {
        $_itemTotal.html($_itemTotal.text() + '<span class="remove-row"></span>');
      }
    });

    var el = this.$summary.find(this.options.summaryTotal);
    if (warning) {
      this.clearNotice(el, '', '.fa-exclamation-triangle');
      this.highlightNotice(el, true, {
        highlightNotice: true,
        highlightIconAddClass: ' ',
        highlightMessage: bq.messages.global.itemsHaveDifferentCurrency
      });
    } else {
      this.clearNotice(el, '', '.fa-exclamation-triangle');
    }
  },

  calculateSummary: function() {
    var rows = this.$grid.find(this.options.rowParent  + ':not(".hidden")'),
        count = 0,
        total = 0,
        $this = this;

    rows.each(function() {
      var row = $(this),
          qty = row.find($this.options.qtyInput).val(),
          minQty = parseFloat(row.find($this.options.qtyInput).prop('min')),
          qtyToCompare = isNaN(minQty) || minQty === 0 ? 1 : minQty,
          itemTotal = row.find($this.options.itemTotal).text(),
          itemUnitPrice = row.find($this.options.itemPrice).text();

      if (row.find($this.options.itemTotalBase) && row.find($this.options.itemTotalBase).text()) {
        itemTotal = row.find($this.options.itemTotalBase).text();
      }

      if(qty <= 0 || qty === '' || isNaN(qty)) { qty = 0; }

      if(qty >= qtyToCompare && itemTotal.search('-') < 0) {
        count += 1;
        total += qty * accounting.unformat(itemUnitPrice);
      }

    });

    if(count < 0 || count === '' || isNaN(count)) { count = 0; }
    if(total === 0 || total === '' || !total || isNaN(total)) { total = 0.00; }

    this.$summary.find(this.options.summaryCount).text(count);
    this.$summary.find(this.options.summaryTotal).html(accounting.formatMoney(total));
  },

  setOrigQty: function() {
    var rows = this.$grid.find(this.options.rowParent),
        $this = this;

    rows.each(function() {
      var row = $(this),
          qtyInput = row.find($this.options.qtyInput);

      qtyInput.data('orig', qtyInput.val());

    });

  },

  highlightNotice: function(el, show, options = {}) {
    var opt = Object.keys(options).length ? options : this.options;
    var classes = 'has-warning has-feedback';
    var iconClassAdditional = opt.highlightIconAddClass ? opt.highlightIconAddClass : 'form-control-feedback';

    if (opt.highlightNotice) {
      if (show) {
        var $parent = el.parent();
        var iconClasses = 'fa fa-exclamation-triangle text-warning ' + iconClassAdditional;
        var $icon = $('<i></i>').addClass(iconClasses);
        $parent.append($icon).addClass(classes);

        if (opt.highlightMessage) {
          $icon.tooltip({
            title: opt.highlightMessage
          });
        }
      } else {
        this.clearNotice(el, classes);
      }
    }
  },

  resetSummary: function() {
    if(this.options.highlightChange) {
      this.setOrigQty();
      var rows = this.$grid.find(this.options.rowParent),
          $this = this;

      rows.each(function() {
        var row = $(this),
            qtyInput = row.find($this.options.qtyInput);
        $this.clearNotice(qtyInput);
      });
    }

    this.update();
  },

  clearNotice: function(el, classes = '', tooltipClass = '.form-control-feedback') {
    var $parent = el.parent();
    $parent.removeClass(classes);
    $(tooltipClass, $parent).tooltip('destroy').remove();
  },

  catchEventChange: function(e) {
    bq.debug.log("Grid Summary : event caught [bq.gridSummary.change]", e);
    var $this = e.data.thiz;
    $this.update();
  },

  catchEventReset: function(e) {
    bq.debug.log("Grid Summary : event caught [bq.gridSummary.reset]", e);
    var $this = e.data.thiz;
    $this.resetSummary();
  },

  catchEventQtyChange: function(e) {
    bq.debug.log("Grid Summary : event caught : change on qty input", e);
    $(e.target).parsley().validate();
    var $this = e.data.thiz;
    $this.update();
  },

  catchEventQuickOrder: function(e) {
    bq.debug.log("Grid Summary : event caught : quick order event", e);
    var $this = e.data.thiz;
    $this.$isQuickOrder = true;
    $this.update();
  },

  throwEventUpdated: function() {
    bq.debug.log("Grid Summary : event thrown [bq.gridSummary.updated]");
    this.$element.trigger('bq.gridSummary.updated', this);
  },

  getMinTierPrice: function (prices, minPrice, inputQty) {
    inputQty = parseFloat(inputQty);

    $(prices).each(function(index, row) {
      var rowPrice = parseFloat(row.price);
      var qty = parseFloat(row.qty);

      //0.0001 avoid comparison issue with floats
      if (((inputQty + 0.0001) > qty) && (minPrice > rowPrice)) {
        minPrice = rowPrice;
      }
    });

    return minPrice;
  }
};

// GRID SUMMARY PLUGIN DEFINITION
// =======================

var gridSummaryold = $.fn.gridSummary;

$.fn.gridSummary = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.gridSummary');
    var options = $.extend({}, bq.gridSummary.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.gridSummary', (data = new bq.gridSummary(this, options))); }
    data.init();
  });
};

$.fn.gridSummary.Constructor = bq.gridSummary;

// GRID SUMMARY NO CONFLICT
// =================

$.fn.gridSummary.noConflict = function () {
  $.fn.gridSummary = gridSummaryold;
  return this;
};

// GRID SUMMARY DATA-API
// ==============

bq.gridSummaryInit = function() {
  $('[data-bq="grid-summary"]').each(function () {
    var el = $(this);
    if(el.data('bq.gridSummary')) { return; }
    el.gridSummary(el.data());
  });
};

bq.init.push(bq.gridSummaryInit);
